import { render, staticRenderFns } from "./PcTms.vue?vue&type=template&id=4a9cf5d6&scoped=true&"
import script from "./PcTms.vue?vue&type=script&lang=js&"
export * from "./PcTms.vue?vue&type=script&lang=js&"
import style0 from "./PcTms.vue?vue&type=style&index=0&id=4a9cf5d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9cf5d6",
  null
  
)

export default component.exports